import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import Spinner from 'react-bootstrap/Spinner';
import Map from '../../components/Map/Map';
import moment from 'moment';

import { API } from 'aws-amplify';
import { MdClear } from 'react-icons/md';
import './DeviceMap.scss';


const params = {
    headers: {
        'x-api-key': process.env.REACT_APP_API_KEY,
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
}

let markersList = [];
// let covers = [];

async function addMarkers(map, links) {
    // Import the marker library
    const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
  
    let infoWindow;
    const markers = [];
  
    links.forEach((link) => {
      const icon = document.createElement("img");
      icon.src = link.icon;
  
      const marker = new AdvancedMarkerElement({
        map,
        position: link.coords,
        title: link.title,
        content: icon,
      });
  
      marker.addListener("click", () => {
        if (infoWindow) {
          infoWindow.close();
        }
  
        infoWindow = new window.google.maps.InfoWindow({
          content: link.content,
        });
  
        infoWindow.open(map, marker);
      });
  
      markers.push({
        id: link.id,
        marker: marker,
      });
    });

    markersList = markers;
  
    return markers;
}

const DeviceMap = (props) => {
	const [assets, setAssets] = useState([]);
	const [assetList, setAssetList] = useState([]);

	const [sites, setSites] = useState([]);
	const [siteList, setSiteList] = useState([]);

	const [location, setLocation] = useState('');
	const [asset,setAsset] = useState('');
	const [siteAddress,setSiteAddress] = useState('');

	const [isLoading, setIsLoading] = useState(false);
    const [mapTasks, setMapTasks] = useState([]);
	const [locationList, setLocationList] = useState([]);
    const [countryList, setCountryList] = useState([]);
	const [country, setCountry] = useState('');
	const [status, setStatus] = useState('');
	const [showType, setShowType] = useState('site');

    // GMaps icons
    // https://sites.google.com/site/gmapsdevelopment/

    // const pin_red = "https://maps.google.com/mapfiles/ms/icons/red-dot.png";
    const pin_green = "https://maps.google.com/mapfiles/ms/icons/green-dot.png";
    const pin_yellow = "https://maps.google.com/mapfiles/ms/icons/yellow-dot.png";
    // const pin_orange = "https://maps.google.com/mapfiles/ms/icons/orange-dot.png";

    let formatDate = ['DD-MM-YYYY','DD/MM/YYYY HH:mm:ss']
    if (props.formatDate!==formatDate[0]){
        formatDate = ['MM-DD-YYYY','MM/DD/YYYY HH:mm:ss']
    }

    // Load asset
    /* eslint-disable no-alert, no-console */
    useEffect(()=>{
        const fetchAssets = async () => {
            setIsLoading(true);

            let assets = await API.get('asset_projection','/', params)
            assets = assets.sort((a, b) => (a.name > b.name) ? 1 : -1)

            //Get user asset list
            let user_assets = []
            user_assets = await API.get('user_assets','/' + props.user.username, params)
            // user_assets = props.user.user_assets

            let assetsFullFiltered = []
            let assetsFiltered = []
            // console.log(user_assets)
            if (user_assets && user_assets.assets){
                user_assets = user_assets.assets;
                assetsFullFiltered = assets.filter(x => user_assets.find(i => i === x.id));
                assetsFiltered = assetsFullFiltered.map(i => i.site_id);
            }
            // console.log(assetsFiltered)
            if (assetsFiltered.length > 0){
                let data = await API.get('sites','/', params)
                data = data.sort((a, b) => (a.name > b.name) ? 1 : -1).filter(item => item.active === true  && item.status === 'active')
                data = data.map(item => {
                    // let stat = pin_green;
                    // switch (item.status) {
                    //     case 'active': 
                    //     stat = pin_green; 
                    //     break;
                    //     case 'inactive': 
                    //     stat = pin_yellow; 
                    //     break;      
                    //     case 'removed': 
                    //     stat = pin_red; 
                    //     break;  
                    //     default:
                    //     stat = pin_green; 
                    // }
                    
                    let assetList = assets
                                        .filter(x => x.site_id === item.id && x.status === 'active')
                                        .map(x => {
                                            return {
                                                id:x.id, 
                                                name:x.name, 
                                                last_update: x.last_update,
                                                alert: !moment(x.last_update).isSameOrAfter(new Date(), "day") 
                                            } })

                    return {...item, 
                            statusCss: //assetList.find(x => x.last_update === undefined) ? pin_orange :
                                       assetList.find(x => x.alert === true) ? pin_yellow : pin_green,
                            // statusCss: stat,
                            statusCssTxt: //assetList.find(x => x.last_update === undefined) ? 'pin_orange' :  
                                        assetList.find(x => x.alert === true) ? 'pin_yellow' : 'pin_green',
                            assets: assetList
                    }})

                if  (props.user.administrator==='false')
                    data = data.filter(item => assetsFiltered.find(x => x === item.id))

                setSites(data);
                setSiteList(data);
                setAssets(assetsFullFiltered);
                setAssetList(assetsFullFiltered);
            }
            setIsLoading(false);
        }

        if (props.user && Object.keys(props.user).length > 0 && assets.length === 0)
            fetchAssets();

    }, [props.user]);


    // Load country
	useEffect(()=>{
		const fetchCountry = async () => {
            let loc = [...new Set(sites.map(item => item.country))];
            loc = loc.filter(item => item !== undefined);
            loc.sort((a, b) => (a > b) ? 1 : -1)

            if (loc.length === 1)
                setCountry(loc[0]);

			setCountryList(loc);
		}
        fetchCountry();

    }, [sites]);

    // Load location
	useEffect(()=>{
		const fetchLocation = async () => {
            let loc=[]
            if (country){
                loc = [...new Set(sites.filter(item => item.country === country).map(item => item.location))];
            }else{
                loc = [...new Set(sites.map(item => item.location))];
            }
            loc = loc.filter(item => item !== undefined);
            loc.sort((a, b) => (a > b) ? 1 : -1)
			setLocationList(loc);
            setLocation('');
		}
        fetchLocation();
    }, [sites, country]);

    // Load map
    useEffect(()=>{

        // let link = []
        setMapTasks([]);

        const showSitesInMap = () => {
            for (let i = 0; i < siteList.length; i++) {

                let lat = 0;
                let long = 0;
                if (siteList[i].latitude) {
                    lat = parseFloat(siteList[i].latitude)
                }
                if (siteList[i].longitude){
                    long = parseFloat(siteList[i].longitude)
                }

                // siteList[i].icon = pin_red;

                // let last_upd = 'Not Available'
                // if (siteList[i].last_update)
                //     last_upd =  moment.utc(new Date(assetList[i].last_update)).local().format(formatDate[1]);

                let aList = ''
                
                for (let j = 0; j < siteList[i].assets.length; j++) {
                let last_upd = 'Not Available'
                if (siteList[i].assets[j].last_update){
                    let alertText = siteList[i].assets[j].alert ? 'text-danger' : 'text-dark'
                    last_upd = '<span class="'+ alertText +'">'+ 
                                moment.utc(new Date(siteList[i].assets[j].last_update)).local().format(formatDate[1]) +'</span>';
                }

                    aList += '<span class="text-dark">'+ siteList[i].assets[j].name + ' - '+ 
                    last_upd +'</span><br/>'
                }

                // Show only VPN WireGuard 10.66.X.X
                let vpn = ''
                if (siteList[i].vpn  && siteList[i].vpn.substring(0, 5) ==='10.66') 
                    vpn = '<span><a href="http://' + siteList[i].vpn + '/" target="blank" class="btn btn-danger shadow-none mt-2 text-nowrap p-1 px-3 "> Traffic Web UI </a></span>'

                // create marker content
                const link = {
                    id: siteList[i].id,
                    coords: { lat: +lat, lng: +long },
                    icon: siteList[i].statusCss,
                    content:'<div class="map-div">'+
                    '<span class="map-dev">' +
                        '<a href="/site_det/' + siteList[i].id + '" class="text-primary" id="marker-link-${siteList[i].id}">' + siteList[i].name + '</a>' +
                    '</span><br/><br/>' +
                    '<span class="text-dark">'+ siteList[i].address  +'</span><br/>' +
                    '<span class="text-dark"><strong>'+ siteList[i].location  +'</strong></span><br/><br/>' +
                    '<span class="text-dark"><strong>Sensors</strong></span><br/>' +
                    aList +
                    '<br/>' +
                    '<span class="text-secondary small">Location: '+ siteList[i].latitude  +', '+ siteList[i].longitude +'</span><br/>' +
                    // '<span class="text-secondary small">Last Update: '+ last_upd +'</span>' +                
                    vpn +
                    '</div>'
                    }

                setMapTasks(sites => [...sites, link]);

            }
        }

        const showAssetsInMap = () => {
            for (let i = 0; i < assetList.length; i++) {

                let lat = 0;
                let long = 0;
                if (assetList[i].latitude) {
                    lat = parseFloat(assetList[i].latitude)
                }
                if (assetList[i].longitude){
                    long = parseFloat(assetList[i].longitude)
                }
                
                let last_upd = 'Not Available'
                if (assetList[i].last_update){
                    last_upd = '<span class="text-dark">'+ moment.utc(new Date(assetList[i].last_update)).local().format(formatDate[1]) +'</span>';
                }

                // create marker content
                const link = {
                    id: assetList[i].id,
                    coords: { lat: +lat, lng: +long },
                    icon: pin_green,
                    content:'<div class="map-div">'+
                    '<span class="map-dev">' +
                        '<a href="/device_info/' + assetList[i].id + '" class="text-primary" id="marker-link-${siteList[i].id}">' + assetList[i].name + '</a>' +
                    '</span><br/><br/>' +
                    '<span class="text-dark"><strong>'+ assetList[i].location  +'</strong></span><br/>' +
                    '<span class="text-dark">'+ assetList[i].address + ' - ' + last_upd +'</span><br/><br/>' +
                    '<span class="text-secondary small">Location: '+ assetList[i].latitude  +', '+ assetList[i].longitude +'</span><br/>' +
                    '</div>'
                    }

                setMapTasks(assets => [...assets, link]);

            }
        }

        if (showType === 'site'){
            showSitesInMap();
        } else {
            showAssetsInMap();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [siteList, assetList, showType]);

    // Load Map
    // Add initial coordinates and zoom to the map, it will re-center and resize when it finishes loading assets
    const mapProps = {
        options: { center: { lat: parseFloat(process.env.REACT_APP_MAP_LAT), lng: parseFloat(process.env.REACT_APP_MAP_LNG) }, zoom: 12, scrollwheel: true, mapId: "de70c7e1386f9fba" },

        onMount: addMarkers,
        onMountProps: mapTasks,
        className: 'gmaps',
    }

    // Reload the map only when necessary
    const MemoMap = useCallback(<Map {...mapProps} />, [mapProps])

    useEffect(() => {

        const handleSearchSite = () => {
            let results = sites;

            // Site Reference
            if (asset){
                results = results.filter(results =>
                    results.name && results.name.toLowerCase().includes(asset.toLowerCase()) )
            }
            // Site Address
            if (siteAddress){
                results = results.filter(results =>
                    results.address && results.address.toLowerCase().includes(siteAddress.toLowerCase()) )
            }
            // country
            if (country){
                results = results.filter(results =>
                    results.country && results.country.toLowerCase().includes(country.toLowerCase())
            )}
            // Location
            if (location){
                results = results.filter(results =>
                    results.location && results.location.toLowerCase().includes(location.toLowerCase())
            )}
            // status
            if (status){
                results = results.filter(results =>
                    results.statusCssTxt && results.statusCssTxt.includes(status)
            )}
            setSiteList(results);
        }

        const handleSearchAsset = () => {
            let results = assets;

            // Site Reference
            if (asset){
                results = results.filter(results =>
                    results.name && results.name.toLowerCase().includes(asset.toLowerCase()) )
            }
            // Site Address
            if (siteAddress){
                results = results.filter(results =>
                    results.address && results.address.toLowerCase().includes(siteAddress.toLowerCase()) )
            }
            // country
            if (country){
                results = results.filter(results =>
                    results.country && results.country.toLowerCase().includes(country.toLowerCase())
            )}
            // Location
            if (location){
                results = results.filter(results =>
                    results.location && results.location.toLowerCase().includes(location.toLowerCase())
            )}
            // status
            if (status){
                results = results.filter(results =>
                    results.statusCssTxt && results.statusCssTxt.includes(status)
            )}
            setAssetList(results);
        }

        if (showType === 'site') {
            handleSearchSite();
        } else if (showType === 'asset') {
            handleSearchAsset();
        }

        }, [location, country, asset, siteAddress, sites, status, showType]);

    const handleClearSearch = () =>{
		setLocation('');
        setCountry('');
        setAsset('');
        setSiteAddress('');
        setStatus('');
        setShowType('site');
	}

    const handleSelLocation = (item) =>{
        const marker = markersList.find(i => i.id === item)

        if (marker){
            // console.log(alert(marker.id))
            new window.google.maps.event.trigger( marker.marker, 'click' );
        }
    }

return (
    <div className="DeviceMap">
        <div className="col-md-12">
		    <div className="row header">Assets</div>
        </div>
        <div className="col-md-12 div-content pt-0">
            <div className="row">
                <div className="col-11 search-box rounded bg-light ">
                    <Form.Group controlId="site_ref" className="col-2">
                    <Form.Label>Site</Form.Label>
                    <Form.Control
                        as="input"
                        value={asset}
                        onChange={e => {setAsset(e.target.value)}}
                        type="text" />
                    </Form.Group>
                    <Form.Group controlId="site_address" className="col-2">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                        as="input"
                        value={siteAddress}
                        onChange={e => {setSiteAddress(e.target.value)}}
                        type="text" />
                    </Form.Group>
                    <Form.Group controlId="country" className="col-md-2">
                        <Form.Label>Country</Form.Label>
                        <Form.Control
                            as="select"
                            value={country}
                            onChange={e => {setCountry(e.target.value)}}>
                                <option value=""></option>
                                {countryList.map((item, i) =>
                                    <option key={`country`+i} value={item}>{item}</option>
                                    )}

                        </Form.Control>
                    </Form.Group>
                    <Form.Group controlId="location" className="col-2">
                        <Form.Label>Location</Form.Label>
                        <Form.Control
                            as="select"
                            value={location}
                            onChange={e => {setLocation(e.target.value)}}>
                                <option value=""></option>
                                {locationList.map((item, i) =>
                                    <option key={`loc`+i} value={item}>{item}</option>
                                    )}
                        </Form.Control>
                    </Form.Group>
                    <Form.Group controlId="status" className="col-2">
                        <Form.Label>Status</Form.Label><br/>
                        <ToggleButtonGroup type="radio" name="options" value={status} >
                            <ToggleButton variant="outline-secondary" className="px-2" value="" onClick={() => setStatus('')} >
                                All
                            </ToggleButton>
                            <ToggleButton variant="outline-success" className="px-2" value="pin_green" onClick={() => setStatus('pin_green')} >
                                Active
                            </ToggleButton>
                            <ToggleButton variant="outline-danger" className="px-2" value="pin_yellow" onClick={() => setStatus('pin_yellow')} >
                                Alert
                            </ToggleButton>
                        </ToggleButtonGroup> 
                    </Form.Group>
                    <Form.Group controlId="status" className="col-2">
                        <Form.Label>View</Form.Label><br/>
                        <ToggleButtonGroup type="radio" name="options" value={showType} >
                            <ToggleButton variant="outline-secondary" className="px-2" value="site" onClick={() => setShowType('site')} >
                                Sites
                            </ToggleButton>
                            <ToggleButton variant="outline-success" className="px-2" value="asset" onClick={() => setShowType('asset')} >
                                Assets
                            </ToggleButton>
                        </ToggleButtonGroup> 
                    </Form.Group>
                </div>
                <div className="col-1 search-box rounded bg-light ">
                    <div className="col m-auto p-0">
                        <Button className='close-button' variant="danger" size="sm" onClick={handleClearSearch}>
                            Clear <MdClear />
                        </Button>
                    </div>
                </div>
                {(!isLoading) ? (
                <div className="col-md-12">
                     <div className="row">
                        <div className="col-md-3 scroller">
                        {(siteList.length === 0) ? (
                            <div className="col-md-12 text-center text-secondary"></div>
                        ):(
                        <ListGroup defaultActiveKey="#">
                            {showType == 'site' ? siteList.map((item, i) => (
                                <ListGroup.Item key={item.id} className="list-group-item" action onClick={()=>handleSelLocation(item.id)}>{item.name}-{item.location}</ListGroup.Item>
                            )) : assetList.map((item, i) => (
                                <ListGroup.Item key={item.id} className="list-group-item" action onClick={()=>handleSelLocation(item.id)}>{item.name}-{item.location}</ListGroup.Item>
                            ))}
                        </ListGroup>
                        )}
                        </div>
                        <div className="col-md-9 p-0">
                            <div>
                            {MemoMap}
                            </div>
                            <div className='small py-1'>                              
                                <img src={pin_green} alt="" height="16" width="16" />Active | 
                                {/* <img src={pin_yellow} alt="" height="16" width="16" />Inactive |  */}
                                <img src={pin_yellow} alt="" height="16" width="16" />Comms Alert 
                                {/* <img src={pin_orange} alt="" height="16" width="16" />Installation in Progress */}
                            </div>
                        </div>

                    </div>
                </div>
                ):(
                <div className="col-md-12">
                <Spinner animation="grow" size="sm" role="status" variant="warning" />
                <span className="text-dark">  Loading...</span>
                </div>
                )}
            </div>
        </div>
    </div>
);
}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        formatDate: state.auth.formatDate,
    };
  };

export default connect(mapStateToProps)(DeviceMap);
